var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 40,
    fill: "url(#pattern0_49_46)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_49_46",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_49_46",
    transform: "matrix(0.010101 0 0 0.0111111 0.0454545 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_49_46",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACEUlEQVR4nO3cy03DUBSE4bMilMBrRRf0QCcQ2BHWNMOeInisgBboAIGEskA/smSkkAXy43hyHc9XAOfM6MrxwtwIMzMzMzOzsQJ2gUvgCfiku2/gDbgFTjadqyjAEfDao9z/Sr/ZdL6STvIQJa86i6mrHxdD+wKOY8rqZ7LCXUwZ8IHOaUyVsOSxqt7AHoELYOaiNV6qNzSfaF3Z7U+2aLltM3fRGg8uWuPDRYu4aBEXLeKiRVy0iIve0qKXwBVw0ORvxsCazK12BRb17p2lLdfQomvgIbSZW5fdWdpyDe33DZypzVxgr0/wtOUGGVYYFy3iokVctIiLFnHRIqMvmqzlkrIos4dyGFnLJWVRZg/lMLKWS8qizB7KYWQtl5RFmT2Uw8haLimLMnsoh5G1XFIWZfYoYlhhXLSIixZx0SIuWsRFi4y+aLKWS8qizB7KYWQtl5RFmT2Uw8haLimLMnsoh5G1XFIWZfZQDiNruaQsyuyhHEbWcklZlNmjiGGFcdEiLlrERYu4aBEXLTKaotc/QP+VtlxLbeYCh32Cpy03gQ/Rr/sET1uuoWX95bz/tWLgoicr2tr0wmPlokVctIiLFnHRBRetvI5tW7yXfMEgU7/qp7rPzdo571L0rL5izJp5BnZaF71yrbHLblbyYaeS1072vHr++Afyj+pl4b56XHQ+yWZmZmZmZmZmZmYxGT9FjL/IPK7v0AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.25f367d12be4982b2c1ed22c9e138311.svg";
export { ForwardRef as ReactComponent };